import Footer from './footer.jsx'
import Header from './header.jsx'
import css from './unauthorized-layout.scss'

const UnauthorizedLayout = (props) => {
    return (
        <div className={css.root}>
            <Header />
            <main className={css.mainBackground}>
                {props.children}
            </main>
            <Footer />
        </div>
    );
}

export default UnauthorizedLayout;